import {CodeBlock} from 'src/cms/partials/content/code-highlight/CodeBlock'
import {LedgerModel} from '../Model/Model'

interface Props {
  entry: LedgerModel
  handleClose: () => void
}

const ViewLedgerDiff = ({entry, handleClose}: Props) => {
  return (
    <div className='modal show d-block' style={{background: 'rgba(0,0,0,0.5)'}}>
      <div className='modal-dialog modal-xl modal-dialog-scrollable'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>
              {entry.actor} {entry.event} {entry.model} #{entry.recordableId}
            </h5>
            <button className='btn-close' onClick={handleClose} />
          </div>
          <div className='modal-body'>
            <div className='row'>
              <div className='col-md-6'>
                <h6>Old Values</h6>
                <CodeBlock
                  code={JSON.stringify(entry.oldValues ?? {}, null, 2)}
                  language='json'
                />
              </div>
              <div className='col-md-6'>
                <h6>New Values</h6>
                <CodeBlock
                  code={JSON.stringify(entry.newValues ?? {}, null, 2)}
                  language='json'
                />
              </div>
            </div>
            {entry.changedFields.length > 0 && (
              <div className='mt-3'>
                <h6>Changed Fields</h6>
                <p>{entry.changedFields.join(', ')}</p>
              </div>
            )}
          </div>
          <div className='modal-footer'>
            <button className='btn btn-secondary btn-sm' onClick={handleClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewLedgerDiff
